export default __webpack_public_path__ + "static/media/calendar-view-selected.634e9eda.svg";